<template>
    <footer class="text-muted text-center">
        {{$t('COPYRIGHT_TEXT')}}
    </footer>
</template>
<script>
    export default {

    }
</script>